import {createContext, useContext} from 'react';

export const createStrictContext = <T>() => {
    const context = createContext<T | undefined>(undefined);

    const useStrictContext = (): T => {
        const data = useContext(context);
        if (!data) {
            throw new Error('useStrictContext must be used within the corresponding provider');
        }
        return data;
    };

    return [context.Provider, useStrictContext] as const;
};
